"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelManager = void 0;
var AppCore_1 = require("../AppCore");
var LevelManager = /** @class */ (function () {
    function LevelManager(_levels) {
        this._levels = _levels;
        this.currentLevelIndex = 0;
    }
    LevelManager.prototype.startLevel = function () {
        this.currentLevel.quiz.nextWord();
    };
    LevelManager.prototype.restartLevel = function () {
        this.currentLevel.quiz.resetWords();
    };
    LevelManager.prototype.completeLevel = function () {
        this.currentLevelIndex++;
    };
    LevelManager.prototype.checkAnswer = function (answer) {
        var _a;
        return ((_a = AppCore_1.AppCore.instance.getWordById(this.currentLevel.quiz.currentWord)) === null || _a === void 0 ? void 0 : _a.text.toUpperCase()) === answer.toUpperCase();
    };
    LevelManager.prototype.hasCompletedLevel = function () {
        this.currentLevel.quiz.nextWord();
        if (this.currentLevel.quiz.currentWord == null) {
            return true;
        }
        return false;
    };
    Object.defineProperty(LevelManager.prototype, "currentLevel", {
        get: function () { return this._levels[this.currentLevelIndex]; },
        enumerable: false,
        configurable: true
    });
    return LevelManager;
}());
exports.LevelManager = LevelManager;
